import { createContext, useContext } from 'react';

import { Bonus } from '../../../../../types/bonus';
import { ReactionType } from '../../types/reaction';
import { Reaction } from './lib/reaction';

interface ReactionContextValue {
	bonus: Bonus;
	createReaction: (type: ReactionType) => void;
	isLoading: boolean;
	onToggle: () => void;
	removeReaction: (reaction: Reaction) => void;
	replaceReaction: (change: { from: Reaction; to: ReactionType }) => void;
	selected?: Reaction;
}

export const ReactionSelectContext = createContext({
	bonus: {},
	createReaction: (_type: ReactionType) => void 0,
	isLoading: false,
	onToggle: () => void 0,
	removeReaction: (_reaction: Reaction) => void 0,
	replaceReaction: (_change: { from: Reaction; to: ReactionType }) => void 0,
	selected: undefined,
} as ReactionContextValue);

export const useReactionContext = () => useContext(ReactionSelectContext);
